// Simple script to strike through unavailable variants on page load
document.addEventListener('DOMContentLoaded', function() {
  const variantContainers = document.querySelectorAll('variant-radios, variant-selects');
  
  variantContainers.forEach(container => {
    const variantData = container.querySelector('[data-variant]');
    if (!variantData) return;
    
    const variants = JSON.parse(variantData.textContent);
    const labels = container.querySelectorAll('label');
    
    labels.forEach(label => {
      const input = container.querySelector(`input[id="${label.getAttribute('for')}"]`);
      if (!input) return;
      
      const value = input.value;
      const isAvailable = variants.some(variant => 
        (variant.option1 === value || variant.option2 === value || variant.option3 === value) && variant.available
      );
      
      if (!isAvailable) {
        label.classList.add('variant-unavailable');
      }
    });
  });
});